export default __webpack_public_path__ + "static/media/buttonBHover.4797d782.png";